var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"restaurant-cta-list list-unstyled"},_vm._l((_vm.restaurants),function(restaurant){return _c('li',{key:restaurant.name},[_c('restaurant-cta',_vm._b({},'restaurant-cta',restaurant,false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }